export class StihlUserDTO {
  IdUser: string;
  Status: boolean;
  Guid: string;
  Name: string;
  Surname: string;
  Email: string;
  RolesListInt: number[];
  RolesListString: string[];
  PermissionsListInt: number[];
  PermissionsListString: string[];
  IdDistributor: number;
  DistributorZone: number | null;
  RolSSO: number;
  OrgGuid: string;
  OrgName: string;
  OrgAccount: string;
  OrgAddress: string;
  completeName: string;
  IdLanguageCode: string;
  DistrictManager: string;
  Phone: string;
  IsPremium: boolean;
  IdDistributorType: number;
  IsPrincipalDealer: boolean;
}